export { default as PatientDiscernUpload } from './PatientDiscernUpload';
